/*
  Mocked Models
*/

const mockedModelBase = {
  type: '',
  attributes: {
    title: 'Lightweight Aluminum Pants',
    metaverseFormatsCount: 6,
    metaverseFormatsList: [{
      name: '.blend', isNative: true, id: 21,
    }, {
      name: '.obj', isNative: false, id: 12,
    }, {
      name: '.fbx', isNative: false, id: 5,
    }, {
      name: '.abc', isNative: false, id: 99,
    }],
    price: 29.45,
    productType: 'cg',
    authorUsername: 'lewis',
    imageAlt: null,
    modelInfo: {
      reviewCount: 0,
      likeCount: 0,
      viewCount: 2,
      modelUrl: 'http://localhost:3000/3d-models/character/man/testing-adult-filter-model',
      isCgtVerified: true,
      types: {
        printReady: false,
        animated: false,
        pbr: true,
        rigged: true,
        lowPoly: false,
      },
      modelRating: 0,
      modelRatingCount: 0,
      commentCount: 0,
    },
    categoryTitle: 'Industrial',
    isGameReady: false,
    url: 'http://localhost:3000/3d-models/industrial/industrial-machine/lightweight-aluminum-pants',
    primaryImage: {
      largeUrl: '/assets/3d-model-loading-image.svg',
      gridUrl: '/assets/3d-model-loading-image.svg',
      isAdultContent: false,
    },
    galleryImageUrls: [
      {
        largeUrl: '/assets/no_image_legacy_large.png',
        isAdultContent: false,
      },
    ],
    vrBadges: [],
    shortFormatsList: 'max, obj, fbx, stl, mtl',
    longFormatsList: 'max, obj, fbx, stl, mtl',
    authorIsFromUkraine: true,
    ukraineDonation: true,
    ukraineDonationPercentage: 10,
    badges: [{ text: 'Random tag' }],
    userInfo: {
      userRating: 0,
      username: '',
      userPicture: '',
    },
  },
}

const mockedModelSaleOff = {
  ...mockedModelBase,
  id: 1,
  attributes: {
    ...mockedModelBase.attributes,
    id: 41,
    isSaleOffApplicable: true,
    saleOffDiscount: 10,
  },
}

const mockedEmptyModel = {
  ...mockedModelBase,
  attributes: {
    ...mockedModelBase.attributes,
    id: 1,
    title: undefined,
    modelInfo: {
      ...mockedModelBase.attributes.modelInfo,
      modelUrl: undefined,
    },
    url: undefined,
  },
}

const mockedModelCLD = {
  ...mockedModelBase,
  id: 3,
  attributes: {
    ...mockedModelBase.attributes,
    id: 43,
    isCLDApplicable: true,
  },
}

/*
  Mocked Carts
*/

const mockedCartBase = {
  creditsAvailable: 16.5,
  value: 108.43,
  applicableCldValue: 15,
  saleOffDiscount: 10,
  saleOffColor: 'red',
  itemIds: [45, 63, 85, 44],
}

const mockedCartSaleOff = {
  ...mockedCartBase,
  isSaleOff: true,
}

const mockedCartCLD = {
  ...mockedCartBase,
  isSaleOff: false,
  isCreditsEnabled: true,
}

// Models
export {
  mockedModelSaleOff, mockedModelCLD, mockedEmptyModel,
}

// Carts
export { mockedCartSaleOff, mockedCartCLD }
